import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-dokument-berechtigung';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungDokumentBerechtigungEffects {

    VeranstaltungDokumentBerechtigung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_DOKUMENT_BERECHTIGUNG),
        mergeMap((x: ac.GetVeranstaltungDokumentBerechtigungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungDokumentBerechtigung(x.veranstaltung_id, x.dokument_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungDokumentBerechtigungErfolgreichAction(result, x.veranstaltung_id, x.dokument_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungDokumentBerechtigungFehlerAction(error, x.veranstaltung_id, x.dokument_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
